export default {
  lang_name: 'Francais',
  tab_main: 'Principal', tab_upgrade: 'Amelioration', tab_prestige: 'Prestige', tab_achievement: 'Succes', tab_mission: 'Mission', tab_domination: 'Monde', tab_settings: 'Param.',
  hud_cps: '/s', hud_boost: 'Boost',
  main_tap_area: 'TOUCHE!', main_combo: 'Combo',
  prod_informant: 'Informateur', prod_informant_desc: 'Collecte de renseignements',
  prod_hacker: 'Hacker', prod_hacker_desc: 'Infiltration de reseaux',
  prod_disguiser: 'Deguiseur', prod_disguiser_desc: 'Camouflage humain',
  prod_mindController: 'Controleur Mental', prod_mindController_desc: 'Manipulation d\'opinion',
  prod_secretLab: 'Labo Secret', prod_secretLab_desc: 'Recherche reptilienne',
  prod_mediaCell: 'Cellule Media', prod_mediaCell_desc: 'Controle des medias',
  prod_shadowGovt: 'Gouv. de l\'Ombre', prod_shadowGovt_desc: 'Remplacement de politiciens',
  prod_deepBase: 'Base Profonde', prod_deepBase_desc: 'Mega-base souterraine',
  prod_orbitalStation: 'Station Orbitale', prod_orbitalStation_desc: 'Reseau de surveillance satellite',
  prod_dimensionGate: 'Porte Dimensionnelle', prod_dimensionGate_desc: 'Invoquer des renforts',
  prod_planetController: 'Controle Planetaire', prod_planetController_desc: 'Controle direct de la Terre',
  prod_galacticBeacon: 'Balise Galactique', prod_galacticBeacon_desc: 'Ligne directe avec le QG',
  prod_locked: 'Debloquer : ', prod_locked_prestige: 'Prestige {n}x', prod_locked_time: '{n}min jeu',
  milestone_squad: 'Escouade', milestone_company: 'Compagnie', milestone_battalion: 'Bataillon',
  milestone_regiment: 'Regiment', milestone_division: 'Division', milestone_corps: 'Corps',
  click_basic_training: 'Entrainement de Base', click_combat_training: 'Entrainement au Combat',
  click_psychic_awaken: 'Eveil Psychique', click_transform: 'Amelioration de Forme',
  click_telepathy: 'Telepathie', click_critical_eye: 'Oeil Critique',
  click_dimension_sense: 'Sens Dimensionnel', click_galaxy_field: 'Champ Galactique',
  click_lethal_strike: 'Frappe Létale', click_absolute: 'Infiltration Absolue',
  click_planet_destroyer: 'Destructeur Planetaire', click_galaxy_finger: 'Doigt de l\'Overlord',
  special_info_network: 'Reseau d\'Info', special_info_network_desc: 'Informateur & Hacker x2',
  special_perfect_disguise: 'Deguisement Parfait', special_perfect_disguise_desc: 'Tous agents x1.5',
  special_mass_brainwash: 'Lavage de Cerveau Massif', special_mass_brainwash_desc: 'Controle Mental & Media x3',
  special_shadow_network: 'Reseau de l\'Ombre', special_shadow_network_desc: 'Revenu hors-ligne +25%',
  special_underground_empire: 'Empire Souterrain', special_underground_empire_desc: 'Tous agents x2',
  special_orbital_surveillance: 'Surveillance Orbitale', special_orbital_surveillance_desc: 'Events dores +50%',
  special_dimension_supply: 'Approvisionnement Dimensionnel', special_dimension_supply_desc: 'Revenu touche x5',
  special_galactic_alliance: 'Alliance Galactique', special_galactic_alliance_desc: '🛸 par seconde x10',
  special_combo_master: 'Maitre du Combo', special_combo_master_desc: 'Limite combo x3',
  special_time_warp: 'Saut Temporel', special_time_warp_desc: 'Limite hors-ligne 12h',
  special_agent_synergy: 'Synergie d\'Agents', special_agent_synergy_desc: '🛸 par seconde x1.5',
  special_massive_infiltration: 'Infiltration Massive', special_massive_infiltration_desc: '🛸 par seconde x2',
  subtab_click: 'Clic', subtab_special: 'Special',
  prestige_title: 'Restructuration', prestige_total_ip: '🛸 total gagne', prestige_gc_gain: '💎 a gagner',
  prestige_gc_current: '💎 actuel', prestige_execute: 'Restructurer',
  prestige_confirm: 'Reinitialiser la progression pour {gc} Credits Galactiques ?',
  prestige_ad_bonus: 'Voir pub +50% 💎', prestige_requirement: 'Il faut 10B+ 🛸',
  prestige2_title: 'Restructuration Galactique', prestige2_cores_gain: '🔮 a gagner',
  prestige2_cores_current: '🔮 actuels', prestige2_execute: 'Restructuration Galactique',
  prestige2_requirement: 'Il faut 15+ prestiges et 100+ 💎', prestige2_confirm: 'Reset profond pour {cores} Noyaux Galactiques ?',
  pup_galaxy_mult: 'Multiplicateur Galactique', pup_galaxy_mult_desc: 'CPS x1.5 par niveau (cumul multiplicatif)',
  pup_infil_accel: 'Acceleration d\'Infiltration', pup_infil_accel_desc: 'Commencer avec 100M 🛸 par niveau après prestige',
  pup_tap_enhance: 'Amelioration Touche', pup_tap_enhance_desc: 'Revenu par tap x2 par niveau (cumul multiplicatif)',
  pup_offline_expand: 'Extension Hors-ligne', pup_offline_expand_desc: 'Limite récompense hors-ligne +1h/Nv (base 8h)',
  pup_offline_eff: 'Efficacite Hors-ligne', pup_offline_eff_desc: 'Taux de revenu hors-ligne +10%p/Nv (base 50%)',
  pup_agent_discount: 'Remise Agent', pup_agent_discount_desc: 'Coût agents -10% par niveau (max -50%)',
  pup_auto_click: 'Auto Clic', pup_auto_click_desc: 'Auto-tap 3/sec par niveau (max 15/sec)',
  pup_golden_luck: 'Chance Doree', pup_golden_luck_desc: 'Récompense événement doré +20%/Nv (max +200%)',
  pup_combo_keep: 'Maintien Combo', pup_combo_keep_desc: 'Durée combo +0.5s/Nv (base 2s)',
  pup_quick_start: 'Demarrage Rapide', pup_quick_start_desc: 'Obtenir 1 des 5 premiers agents après prestige',
  p2up_galaxy_speed: 'Vitesse Galactique', p2up_galaxy_speed_desc: '💎 gagnés x2 par niveau au prestige (cumulable)',
  p2up_auto_prestige: 'Auto Prestige', p2up_auto_prestige_desc: 'Prestige auto à 10Mrd 🛸',
  p2up_permanent: 'Agents Permanents', p2up_permanent_desc: 'Garder les 3 premiers types d\'agents après prestige',
  p2up_dimension_accel: 'Acceleration Dimensionnelle', p2up_dimension_accel_desc: 'CPS x5 par niveau (cumulable, permanent)',
  p2up_galaxy_memory: 'Memoire Galactique', p2up_galaxy_memory_desc: 'Garder 3 bonus actifs après prestige',
  p2up_spacetime: 'Courbure Spatio-temporelle', p2up_spacetime_desc: 'Taux revenu hors-ligne à 100% (permanent)',
  p2up_automate: 'Automatisation Galactique', p2up_automate_desc: 'Embaucher agents automatiquement (permanent)',
  rank_e: 'Stagiaire', rank_d: 'Agent Junior', rank_c: 'Agent', rank_b: 'Agent Senior',
  rank_a: 'Cadre', rank_s: 'Directeur', rank_ss: 'Commandant Supreme', rank_sss: 'Overlord Galactique',
  ach_title: 'Succes', ach_filter_all: 'Tous', ach_filter_tap: 'Touche', ach_filter_resource: 'Ressource',
  ach_filter_producer: 'Producteur', ach_filter_prestige: 'Prestige', ach_filter_time: 'Temps',
  ach_filter_special: 'Special', ach_filter_ad: 'Docs', ach_filter_combo: 'Combo',
  ach_t01: 'Premier Pas', ach_t01_reward: '+1 Puissance Touche', ach_t02: 'Echauffement', ach_t02_reward: '+5% Puissance Touche',
  ach_t03: 'Agent Assidu', ach_t03_reward: '+10% Puissance Touche', ach_t04: 'Maitre du Toucher', ach_t04_reward: '+15% Puissance Touche',
  ach_t05: 'Tenacite Reptilienne', ach_t05_reward: '+20% Puissance Touche', ach_t06: 'Doigts Galactiques', ach_t06_reward: '+25% Puissance Touche',
  ach_t07: 'Apprenti Combo', ach_t07_reward: '+0.5s Combo', ach_t08: 'Maitre Combo', ach_t08_reward: '+0.5 Limite Combo',
  ach_r01: 'Petite Intel', ach_r01_reward: '+5% \u{1F6F8}/s', ach_r02: 'Collecteur d\'Intel', ach_r02_reward: '+5% \u{1F6F8}/s',
  ach_r03: 'Coffre Classifie', ach_r03_reward: '+5% \u{1F6F8}/s', ach_r04: 'Infiltration Millionnaire', ach_r04_reward: '+10% \u{1F6F8}/s',
  ach_r05: 'Agent Milliardaire', ach_r05_reward: '+10% \u{1F6F8}/s', ach_r06: 'Ops Billion', ach_r06_reward: '+15% \u{1F6F8}/s',
  ach_r07: 'Empire Quadrillion', ach_r07_reward: '+15% \u{1F6F8}/s', ach_r08: 'Ocean Galactique', ach_r08_reward: '+20% \u{1F6F8}/s',
  ach_r09: 'Univers Cosmique', ach_r09_reward: '+20% \u{1F6F8}/s', ach_r10: 'Infiltration Infinie', ach_r10_reward: '+30% \u{1F6F8}/s',
  ach_g01: 'Premiere Recrue', ach_g01_reward: 'Informateur x1.5', ach_g02: 'Reseau Intel', ach_g02_reward: 'Informateur x2',
  ach_g03: 'Piratage Lance', ach_g03_reward: 'Hacker x2', ach_g04: 'Cyber Legion', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Maitre du Deguisement', ach_g05_reward: 'Deguiseur x2', ach_g06: 'Reseau de Lavage', ach_g06_reward: 'Controleur Mental x2',
  ach_g07: 'Science Folle', ach_g07_reward: 'Labo Secret x2', ach_g08: 'Controle des Medias', ach_g08_reward: 'Cellule Media x2',
  ach_g09: 'Cabinet de l\'Ombre', ach_g09_reward: 'Gouv. de l\'Ombre x2', ach_g10: 'Empire Souterrain', ach_g10_reward: 'Base Profonde x2',
  ach_g11: 'Dominance Orbitale', ach_g11_reward: 'Station Orbitale x2', ach_g12: 'Maitre de la Galaxie', ach_g12_reward: '\u{1F6F8}/s Total x2',
  ach_p01: 'Premiere Restructuration', ach_p01_reward: '+5 💎 Bonus', ach_p02: 'Gout du Cycle', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veteran', ach_p03_reward: '+10% 💎', ach_p04: 'Accro au Prestige', ach_p04_reward: '+15% 💎',
  ach_p05: 'Boucle Infinie', ach_p05_reward: '+20% 💎', ach_p06: 'Memoire Galactique', ach_p06_reward: '+25% 💎',
  ach_p07: 'Restructuration Galactique', ach_p07_reward: '+3 🔮 Bonus', ach_p08: 'Seigneur Dimensionnel', ach_p08_reward: '+20% 🔮',
  ach_h01: 'Nouvelle Recrue', ach_h01_reward: 'Bonus Bienvenue 100 🛸', ach_h02: 'Shift de 1 Heure', ach_h02_reward: '+5% \u{1F6F8}/s',
  ach_h03: 'Demi-Journee', ach_h03_reward: '+10% \u{1F6F8}/s', ach_h04: 'Surveillance 24h', ach_h04_reward: 'Hors-ligne +2h',
  ach_h05: 'Mission de 3 Jours', ach_h05_reward: '\u{1F6F8}/s x1.5', ach_h06: 'Infiltration Hebdomadaire', ach_h06_reward: '\u{1F6F8}/s x2',
  ach_s01: 'Humain Suspect', ach_s01_reward: '1 Doc', ach_s02: 'Depart Propre', ach_s02_reward: 'Titre: Agent Temeraire',
  ach_s03: 'Tout Dedans', ach_s03_reward: '+10% \u{1F6F8}/s', ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Chasseur Dore', ach_s05_reward: 'Freq event -20%', ach_s06: 'Agent Nocturne', ach_s06_reward: '\u{1F6F8}/s nocturne x1.5',
  ach_s07: 'Guerrier F2P', ach_s07_reward: 'Recompense pub +30%', ach_s08: 'Collectionneur', ach_s08_reward: '\u{1F6F8}/s x3',
  ach_a01: 'Debutant Pub', ach_a01_reward: '1 Doc', ach_a02: 'Enthousiaste Pub', ach_a02_reward: '2 Docs',
  ach_a03: 'Maitre Pub', ach_a03_reward: 'Recompense pub +30%', ach_a04: 'Collecteur de Docs', ach_a04_reward: 'Effet doc +20%',
  ach_a05: 'Expert en Docs', ach_a05_reward: 'Effet doc +50%',
  ach_c01: 'Debut Combo', ach_c01_reward: '+0.3s Combo', ach_c02: 'Dans le Rythme', ach_c02_reward: '+0.1 Mult Combo',
  ach_c03: 'Debutant Dore', ach_c03_reward: 'Recompense event +10%', ach_c04: 'Collecteur Dore', ach_c04_reward: 'Freq event -10%',
  ach_c05: 'Maniaque Quotidien', ach_c05_reward: 'Recompense mission +50%',
  golden_intel_leak: 'Fuite d\'Intel !', golden_agent_frenzy: 'Frenesie d\'Agents !', golden_money_launder: 'Blanchiment !',
  golden_facility_boost: 'Surcharge !', golden_supply_drop: 'Approvisionnement Galactique !', golden_touch: 'TOUCHE !',
  golden_ad_double: 'Voir pub pour 2x',
  offline_title: 'Rapport d\'Absence', offline_elapsed: 'Temps ecoule', offline_earned: '🛸 gagne',
  offline_cap: 'Max {h}h applique', offline_claim: 'Recuperer', offline_double: 'Voir pub pour 2x ({amount})',
  offline_hours: '{h}h {m}m',
  settings_title: 'Parametres', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_lang: 'Langue',
  settings_reset: 'Reinitialiser le Jeu', settings_reset_confirm: 'Supprimer TOUTE la progression ?',
  settings_stats: 'Statistiques', settings_total_ip: '🛸 Total Gagne', settings_total_taps: 'Touches Totales',
  settings_total_prestiges: 'Prestiges Totaux', settings_play_time: 'Temps Total', settings_docs_shop: 'Boutique Docs',
  doc_shop_title: 'Boutique Docs Classifies',
  doc_ip_boost: 'Accelerateur de Revenus', doc_ip_boost_desc: '2x production 🛸/s pendant 30 sec',
  doc_mega_tap: 'Entrainement Frappe', doc_mega_tap_desc: '3x revenu de frappe pendant 30 sec',
  doc_auto_click: 'Auto-Infiltrateur', doc_auto_click_desc: 'Auto-frappe 10/sec pendant 30 sec',
  doc_instant_golden: 'Appel Dore Urgent', doc_instant_golden_desc: 'Declencher evenement dore immediatement',
  doc_timeskip: 'Accelerateur Temporel', doc_timeskip_desc: 'Obtenir 2h de revenus 🛸 instantanement',
  doc_prestige_boost: 'Amplificateur Galactique', doc_prestige_boost_desc: '2x 💎 au prochain prestige',
  doc_prestige_boost_active: '💎 x2 en attente pour prochain prestige', doc_prestige_boost_active_badge: '✅ Actif',
  ad_offline_double: 'Double recompense hors-ligne', ad_cps_boost: 'Revenu/s x10 Boost (15s)',
  ad_prestige_bonus: 'Prestige +50% 💎', ad_timeskip: 'Saut Temporel (2h)', ad_free_docs: 'Docs Gratuits',
  ad_golden_double: 'Double recompense doree', ad_start_boost: 'Pack de Demarrage',
  ad_watching: 'Chargement de la pub...', ad_cooldown: 'Disponible dans {t}',
  settings_sfx_test: 'Tester SFX', settings_sound_reset: 'R\u00E9initialiser', settings_sound_reset_done: 'Son r\u00E9initialis\u00E9',
  num_k: 'K', num_m: 'M', num_b: 'Md', num_t: 'Bn', num_qa: 'Qa', num_qi: 'Qi', num_sx: 'Sx', num_sp: 'Sp', num_oc: 'Oc', num_no: 'No', num_dc: 'Dc',
  mission_title: 'Missions Quotidiennes',
  mission_claim: 'Recuperer',
  mission_all_complete: 'Bonus Complet !',
  mission_clear_label: 'MISSION',
  mission_all_clear_label: 'TOUT FAIT',
  ach_unlock_label: 'SUCC\u00C8S',
  mission_diff_easy: 'Facile',
  mission_diff_normal: 'Moyen',
  mission_diff_hard: 'Difficile',
  mission_tap_100: 'Touche Legere',
  mission_tap_100_desc: 'Toucher 100 fois',
  mission_tap_300: 'Mains Chaudes',
  mission_tap_300_desc: 'Toucher 300 fois',
  mission_buy_5: 'Petite Recrue',
  mission_buy_5_desc: 'Acheter 5 producteurs',
  mission_combo_10: 'Debut Combo',
  mission_combo_10_desc: 'Atteindre 10 combo',
  mission_golden_1: 'Coup de Chance',
  mission_golden_1_desc: 'Attraper 1 evenement dore',
  mission_tap_1000: 'Frappe Lourde',
  mission_tap_1000_desc: 'Toucher 1 000 fois',
  mission_buy_20: 'Chef d\'Escouade',
  mission_buy_20_desc: 'Acheter 20 producteurs',
  mission_combo_50: 'Combo Pro',
  mission_combo_50_desc: 'Atteindre 50 combo',
  mission_golden_3: 'Ruee vers l\'Or',
  mission_golden_3_desc: 'Attraper 3 evenements dores',
  mission_earn_1m: 'Ops Million',
  mission_earn_1m_desc: 'Gagner 1M 🛸',
  mission_tap_5000: 'Machine a Toucher',
  mission_tap_5000_desc: 'Toucher 5 000 fois',
  mission_buy_50: 'Constructeur d\'Armee',
  mission_buy_50_desc: 'Acheter 50 producteurs',
  mission_combo_100: 'Dieu du Combo',
  mission_combo_100_desc: 'Atteindre 100 combo',
  mission_golden_5: 'Maitre Dore',
  mission_golden_5_desc: 'Attraper 5 evenements dores',
  mission_earn_1b: 'Agent Milliardaire',
  mission_earn_1b_desc: 'Gagner 1Md 🛸',
  mission_tap_200: 'Doigts rapides',
  mission_tap_200_desc: 'Tapez 200 fois',
  mission_buy_3: 'Premières recrues',
  mission_buy_3_desc: 'Achetez 3 producteurs',
  mission_combo_15: 'Combo débutant',
  mission_combo_15_desc: 'Atteignez 15 combo',
  mission_earn_10k: 'Argent de poche',
  mission_earn_10k_desc: 'Gagnez 10K 🛸',
  mission_earn_100k: 'Collecteur',
  mission_earn_100k_desc: 'Gagnez 100K 🛸',
  mission_tap_500: 'Tapeur régulier',
  mission_tap_500_desc: 'Tapez 500 fois',
  mission_tap_700: 'Implacable',
  mission_tap_700_desc: 'Tapez 700 fois',
  mission_buy_10: 'Chef d\'équipe',
  mission_buy_10_desc: 'Achetez 10 producteurs',
  mission_combo_30: 'Chaîne de combo',
  mission_combo_30_desc: 'Atteignez 30 combo',
  mission_golden_2: 'Double or',
  mission_golden_2_desc: 'Attrapez 2 événements dorés',
  mission_tap_3000: 'Guerrier du tap',
  mission_tap_3000_desc: 'Tapez 3 000 fois',
  mission_buy_30: 'Bataillon',
  mission_buy_30_desc: 'Achetez 30 producteurs',
  mission_combo_75: 'Combo élite',
  mission_combo_75_desc: 'Atteignez 75 combo',
  mission_golden_4: 'Chasseur d\'or',
  mission_golden_4_desc: 'Attrapez 4 événements dorés',
  mission_earn_10m: 'Magnat',
  mission_earn_10m_desc: 'Gagnez 10M 🛸',
  // Conquest
  cq_title: 'Conquête Mondiale',
  cq_progress: 'Conquis',
  cq_infiltration_power: 'Pouvoir d\'infiltration',
  cq_active_conquest: 'Infiltration en cours',
  cq_infiltration_progress: 'Progression d\'infiltration',
  cq_time_remaining: 'Temps estimé',
  cq_start_infiltration: 'Démarrer l\'infiltration',
  cq_stop_infiltration: 'Arrêter l\'infiltration',
  cq_no_power_hint: 'Engagez des agents pour générer du pouvoir d\'infiltration',
  cq_locked: 'Verrouillé',
  cq_available: 'Disponible',
  cq_conquered: 'Conquis',
  cq_popup_title: 'Conquête terminée !',
  cq_popup_desc: 'a été conquis ! Construisez des installations pour devenir plus fort.',
  cq_back: 'Retour',
  cq_invest_title: 'Investir 🛸 pour conquérir',
  cq_current_ip: '🛸 actuel',
  cq_facilities: 'Installations',
  cq_build: 'Construire',
  cq_upgrade: 'Améliorer',
  cq_next_level: 'Suivant',
  cq_counter_intel_title: 'Alerte contre-espionnage !',
  cq_counter_intel_text: 'Votre infiltration en {country} a été détectée ! La progression sera réduite.',
  cq_defend_ad: 'Regarder pub pour défendre',
  cq_accept_loss: 'Accepter la perte',
  cq_ending_title: 'Terre conquise !',
  cq_ending_text: 'La conspiration reptilienne est complète. Toutes les nations s\'inclinent devant l\'empire de l\'ombre.',
  cq_ending_time: 'Temps de jeu',
  cq_ending_prestiges: 'Prestiges',
  cq_ending_total_ip: '🛸 total',
  cq_ending_taps: 'Taps totaux',
  cq_ending_continue: 'Continuer à jouer',
  cq_egypt: 'Égypte', cq_egypt_desc: 'Bases anciennes des pyramides',
  cq_brazil: 'Brésil', cq_brazil_desc: 'Cachettes dans la jungle amazonienne',
  cq_india: 'Inde', cq_india_desc: 'Infiltration du culte Naga',
  cq_australia: 'Australie', cq_australia_desc: 'Bunkers souterrains du désert',
  cq_japan: 'Japon', cq_japan_desc: 'Vol de technologie',
  cq_korea: 'Corée', cq_korea_desc: 'Brèche cyberdéfense NIS',
  cq_uk: 'Royaume-Uni', cq_uk_desc: 'Infiltration royale MI5/MI6',
  cq_russia: 'Russie', cq_russia_desc: 'Opérations sibériennes FSB',
  cq_china: 'Chine', cq_china_desc: 'Surveillance la plus forte au monde',
  cq_usa: 'États-Unis', cq_usa_desc: 'CIA/NSA boss final',
  fac_pyramid_vault: 'Coffre Pyramide', fac_pyramid_vault_d: '\u{1F6F8}/s +5% par niveau',
  fac_nile_network: 'Réseau du Nil', fac_nile_network_d: 'Hors ligne +5% par niveau',
  fac_ancient_lab: 'Labo Ancien', fac_ancient_lab_d: 'TAP +10% par niveau',
  fac_amazon_hideout: 'Cachette Amazone', fac_amazon_hideout_d: 'Réduction +2% par niveau',
  fac_samba_broadcast: 'Diffusion Samba', fac_samba_broadcast_d: '\u{1F6F8}/s +8% par niveau',
  fac_jungle_lab: 'Labo Jungle', fac_jungle_lab_d: 'Golden +5% par niveau',
  fac_naga_temple: 'Temple Naga', fac_naga_temple_d: '💎 +5% par niveau',
  fac_bollywood_studio: 'Studio Bollywood', fac_bollywood_studio_d: 'Hors ligne +8% par niveau',
  fac_caste_network: 'Réseau de Castes', fac_caste_network_d: '\u{1F6F8}/s +12% par niveau',
  fac_desert_bunker: 'Bunker Désert', fac_desert_bunker_d: 'TAP +15% par niveau',
  fac_ayers_signal: 'Signal Ayers', fac_ayers_signal_d: 'Golden +8% par niveau',
  fac_outback_base: 'Base Outback', fac_outback_base_d: '\u{1F6F8}/s +15% par niveau',
  fac_akiba_ai: 'IA Akihabara', fac_akiba_ai_d: '\u{1F6F8}/s +20% par niveau',
  fac_ninja_intel: 'Renseignement Ninja', fac_ninja_intel_d: 'Réduction +3% par niveau',
  fac_tokyo_tower: 'Tour de Tokyo', fac_tokyo_tower_d: '💎 +8% par niveau',
  fac_gangnam_hq: 'QG Gangnam', fac_gangnam_hq_d: '\u{1F6F8}/s +25% par niveau',
  fac_cyber_command: 'Commandement Cyber', fac_cyber_command_d: 'TAP +25% par niveau',
  fac_kpop_brainwash: 'Lavage K-Pop', fac_kpop_brainwash_d: '💎 +10% par niveau',
  fac_royal_infiltrate: 'Infiltration Royale', fac_royal_infiltrate_d: '\u{1F6F8}/s +30% par niveau',
  fac_london_tower: 'Tour de Londres', fac_london_tower_d: 'Hors ligne +15% par niveau',
  fac_mi6_double: 'Agent Double MI6', fac_mi6_double_d: 'Golden +12% par niveau',
  fac_siberia_base: 'Base Sibérie', fac_siberia_base_d: '\u{1F6F8}/s +40% par niveau',
  fac_kgb_remnant: 'Vestige KGB', fac_kgb_remnant_d: 'Réduction +5% par niveau',
  fac_nuke_bunker: 'Bunker Nucléaire', fac_nuke_bunker_d: 'TAP +40% par niveau',
  fac_great_wall: 'Grande Muraille Numérique', fac_great_wall_d: '\u{1F6F8}/s +50% par niveau',
  fac_shenzhen_factory: 'Usine Shenzhen', fac_shenzhen_factory_d: 'Réduction +8% par niveau',
  fac_panda_spy: 'Réseau Espion Panda', fac_panda_spy_d: 'Golden +20% par niveau',
  fac_area51: 'Zone 51', fac_area51_d: '\u{1F6F8}/s +80% par niveau',
  fac_pentagon: 'Pentagone', fac_pentagon_d: 'TAP +80% par niveau',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% par niveau',

  buy: 'Acheter', max: 'MAX', level: 'Nv.', locked: 'Verrouille', unlocked: 'Deverrouille',
  upgrade_locked_prev: 'Apprenez d\'abord l\'amelioration precedente',
  condition: 'Condition', cost: 'Cout', owned: 'Possede', effect: 'Effet', reward: 'Recompense',
  close: 'Fermer', confirm: 'Confirmer', cancel: 'Annuler',

  // Conquest achievements
  ach_filter_conquest: 'Conquête',
  ach_q01: 'Première Conquête', ach_q01_reward: '\u{1F6F8}/s +10%',
  ach_q02: 'Triple Menace', ach_q02_reward: 'TAP +10%',
  ach_q03: 'La Moitié du Monde', ach_q03_reward: '💎 +15%',
  ach_q04: 'Sept Drapeaux', ach_q04_reward: 'Offline +20%',
  ach_q05: 'Dominateur Mondial', ach_q05_reward: '\u{1F6F8}/s x3',
  ach_q06: 'Maître des Installations', ach_q06_reward: '\u{1F6F8}/s x2',
  milestone_next: 'Prochain',
  settings_conquest: 'Conquête',

  // Currency info
  currency_ip_name: 'Points d\'Infiltration (IP)',
  currency_ip_earn: 'Tapez, production auto, revenus hors ligne et récompenses publicitaires',
  currency_ip_use: 'Recruter des agents, acheter des améliorations, investir dans les conquêtes',
  currency_gc_name: 'Crédits Galactiques (GC)',
  currency_gc_earn: 'Au prestige (Restructuration) selon les IP totaux accumulés',
  currency_gc_use: 'Acheter des améliorations prestige (multiplicateur de production, efficacité offline, etc.)',
  currency_cores_name: 'Noyaux Galactiques',
  currency_cores_earn: 'Au 2e prestige (Restructuration Galactique) selon les GC totaux',
  currency_cores_use: 'Acheter des améliorations 2e prestige (buffs permanents, automatisation, etc.)',
  currency_docs_name: 'Documents Classifiés',
  currency_docs_earn: 'Missions quotidiennes, publicités ou succès débloqués',
  currency_docs_use: 'Acheter des boosts puissants dans la Boutique Docs (onglet Mission)',
  currency_how_earn: 'Comment obtenir',
  currency_how_use: 'Comment utiliser',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Maîtrise d\'Infiltration',
  pup_infiltration_mastery_desc: 'Puissance d\'infiltration totale +50%/Nv (max +500%)',
  pup_agent_network: 'Réseau d\'Agents',
  pup_agent_network_desc: 'Infiltration +5% par 100 agents par niveau',
  pup_quick_infiltration: 'Infiltration en Chaîne',
  pup_quick_infiltration_desc: 'À la conquête: pays suivant +10% progression/Nv',
  pup_critical_chance: 'Entraînement Critique',
  pup_critical_chance_desc: 'Chance critique tap +3%/Nv (base 10%, max 50%)',
  pup_critical_damage: 'Puissance Critique',
  pup_critical_damage_desc: 'Dégâts critiques +1x/Nv (base x3)',

  // Special upgrades - conquest
  special_spy_master: 'Maître Espion',
  special_spy_master_desc: 'Pouvoir d\'infiltration total x2',

  ad_income_x5: 'Revenus de 30min',
  ad_income_x5_desc: 'Regardez une pub pour obtenir\n{amount} 🛸 instantanément (30 minutes de revenus) !',
  ad_tap_x10: 'Toucher x10 (10s)',
  ad_tap_x10_desc: 'Regardez une pub pour booster\nle revenu du toucher x10 pendant 10 secondes !',
  ad_free_docs_desc: 'Regardez une pub pour obtenir\n1 Document Classifié 📜 gratuit !',
  ad_prestige_desc: 'Regardez une pub pour booster\nvos revenus x10 pendant 15 secondes !',
  cq_tutorial_title: '🌍 Guide de Conquête Mondiale',
  cq_tutorial_text: 'Après avoir conquis un pays, vous pouvez construire des <b>installations</b> !\nAméliorez-les pour des bonus permanents\ncomme <b>RPS, revenu tactile, revenu hors-ligne</b> et plus.\n\nRecrutez des agents pour augmenter le pouvoir d\'infiltration.',
  rank_promote: 'Promouvoir',
  rank_promoted: 'Promotion réussie !',
} as const;
